/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { DocumentProgress } from './documentProgress';
import type { VideoProgress } from './videoProgress';

export type UserResourceProgressUpdateProgress = DocumentProgress | VideoProgress | null;
